import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PageNotFound.css';

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <h1>404 - Stranica nije pronađena</h1>
      <p>Tražena stranica ne postoji ili je uklonjena.</p>
      <Link to="/home" className="return-home">
        Vratite se na početnu stranicu
      </Link>
    </div>
  );
};

export default PageNotFound;